import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Input,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import FileExtension from '../File/Extension';
import FileResolution from '../File/Resolution';
import FileSize from '../File/Size';
import FileStatus from '../File/Status';
import DateTime from '../DateTime';

import {
  userCan,
  userIsAdmin,
} from '../../helpers/Auth';

const DownloadFilesListItem = ({
  file,
  fileSelected,
  currentStatus,
  handleDownloadFiles,
  handleShareFiles,
  handleSelectFile,
  handleRemoveFiles,
}) => {
  const intl = useIntl();

  const fileTo = {
    pathname: `/files/${file.uuid}`,
    state: {
      modal: true,
      closeUrl: window.location.pathname,
    },
  };

  return (
    <tr>
      {(currentStatus === 'accepted' || userIsAdmin()) && (
        <td className="selector">
          <Input
            type="checkbox"
            className="input-check check-s form-check-input"
            value={file.uuid}
            checked={fileSelected}
            onChange={handleSelectFile}
          />
        </td>
      )}
      <td className={`file-image${currentStatus === 'accepted' ? '' : ' without-selector'}`}>
        <Link to={fileTo} className="list-item-img-wrapper">
          <img
            id={`file-img-${file.uuid}`}
            className="list-item-img"
            width="100%"
            src={file.urls.thumbnail}
            srcSet={`${file.urls.thumbnail} 1x, ${file.urls.thumbnailx2} 2x`}
            alt={file.display_name}
          />
        </Link>
      </td>
      <td className="file-name">
        <h5 className="list-item-title">
          <Link to={fileTo} title={file.display_name}>
            {file.display_name}
          </Link>
          <FileStatus
            file={file}
          />
        </h5>
        <div className="list-item-details file-details">
          <div>
            <FileResolution
              file={file}
            />
            <FileExtension
              file={file}
            />
            <FileSize
              file={file}
            />
          </div>
        </div>
      </td>
      <td className="file-owner">
        {file.user.name}
      </td>
      <td className="file-upload">
        <DateTime
          id={`file-date-${file.uuid}`}
          className="file-date"
          dateTime={file.created_at}
        />
      </td>
      <td className="file-actions">
        <ul>
          {(currentStatus === 'accepted' || userIsAdmin()) && (
            <>
              <li>
                <Link
                  to="#download-file"
                  id={`download-file-${file.uuid}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleDownloadFiles([file]);
                  }}
                >
                  <i className="far fa-download" />
                </Link>
                <UncontrolledTooltip target={`download-file-${file.uuid}`}>
                  {intl.formatMessage({ defaultMessage: 'Download' })}
                </UncontrolledTooltip>
              </li>
              {userCan('share_download_requests') && (
                <li>
                  <Link
                    to="#share-file"
                    id={`share-file-${file.uuid}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleShareFiles([file]);
                    }}
                  >
                    <i className="far fa-share-alt" />
                  </Link>
                  <UncontrolledTooltip target={`share-file-${file.uuid}`}>
                    {intl.formatMessage({ defaultMessage: 'Share' })}
                  </UncontrolledTooltip>
                </li>
              )}
            </>
          )}
          {userIsAdmin() && (
            <li>
              <Link
                to="#remove-file"
                id={`remove-file-${file.uuid}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleRemoveFiles([file.uuid]);
                }}
              >
                <i className="far fa-times" />
              </Link>
              <UncontrolledTooltip target={`remove-file-${file.uuid}`}>
                {intl.formatMessage({ defaultMessage: 'Remove file' })}
              </UncontrolledTooltip>
            </li>
          )}
        </ul>
      </td>
    </tr>
  );
};

DownloadFilesListItem.propTypes = {
  file: PropTypes.object.isRequired,
  fileSelected: PropTypes.bool.isRequired,
  currentStatus: PropTypes.string.isRequired,
  handleDownloadFiles: PropTypes.func.isRequired,
  handleShareFiles: PropTypes.func.isRequired,
  handleRemoveFiles: PropTypes.func.isRequired,
  handleSelectFile: PropTypes.func.isRequired,
};

export default DownloadFilesListItem;
